export default "__VITE_ASSET__DFCRh40N__"